import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MatPaginator, MatSort, MatTableDataSource, MAT_DIALOG_DATA } from '@angular/material';
import { first } from 'rxjs/operators';
import { RolePrivilegeService } from 'src/app/services/role.privilege.service';
import { ToastrUtil } from 'src/app/util/toastr.util';
import { WebConstants } from 'src/app/util/web.constants';

@Component({
  selector: 'app-role-privilege-dialog',
  templateUrl: './role-privilege-dialog.component.html',
  styleUrls: ['./role-privilege-dialog.component.scss']
})
export class RolePrivilegeDialogComponent implements OnInit {
  public columnHeader: string[] = [
    'name',
    'description',
    'status',
    'action'
  ];

  public privilegeList: any[] = [];
  public roleId: Number = null;

  // @ts-ignore
  @ViewChild(MatSort) sort: MatSort;
  // @ts-ignore
  @ViewChild(MatPaginator) paginator: MatPaginator;

  public dataSource = new MatTableDataSource();

  constructor(public dialog: MatDialogRef<RolePrivilegeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Number,
    public rolePrivilegeService: RolePrivilegeService,
    public toaster: ToastrUtil) {
    this.roleId = data;

    this.getAllPrivileges(data);
  }

  ngOnInit() {
  }

  getAllPrivileges(roleId: Number): void {
    this.rolePrivilegeService.getPrivilegesByRoleId(roleId)
      .pipe(first())
      .subscribe(response => {
        if (response.code === WebConstants.STATUS.CODE_SUCCESS) {
          if (response.data && response.data.length > WebConstants.INT_ZERO) {
            this.privilegeList = response.data;

            this.dataSource = new MatTableDataSource(this.privilegeList);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
          } else {
            this.privilegeList = [];
          }
        }
      });
  }

  onChange(element: Object, checked: any): void {
    let rolePrivilegeObject = {
      privilegeId: element,
      roleId: this.roleId,
      status: (checked) ? WebConstants.STATUS.CODE.ACTIVE : WebConstants.STATUS.CODE.INACTIVE
    };

    this.rolePrivilegeService.addRolePrivilege(rolePrivilegeObject)
      .pipe(first())
      .subscribe(response => {
        if (response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.toaster.success("Role privilege has been updated", "Success");
        }
      });
  }

  closeDialog(): void {
    this.dialog.close();
  }
}